export const DES_OPPORTUNITY_COLORS = {
  A: "#ff0000",
  M: "#c79200",
  SS: "#32cd32",
  C: "#800080",
  SA: "#008000",
  O: "#000000",
  NW: "#0000ff",
  U: "#ffd700",
  CR: "#7ec8c9",
  E: "#bdbdbd",
  P: "#f4a300",
};

export function getOpportunityColor(code) {
  return DES_OPPORTUNITY_COLORS[code] || "#6c757d";
}

export function parseOpportunityCodes(codes) {
  if (!codes) return [];

  return codes
    .split(",")
    .map(code => code.trim())
    .filter(Boolean);
}
